
import { styled, SxProps, useTheme } from "@mui/material";

export const ImgStyled = styled("img", { label: "buttonContainerInsideOnScreenHelp-Div" })
  (({   theme }) => ({
         width: 40,
        filter: "brightness(50)",

        '+div p':{fontSize: 13,}
}));


export const useClasses = () => {
    const theme = useTheme();
    const classes = {
        overlayStyle: {
          cursor: "pointer",
          pointerEvents: "auto",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          overflow: "hidden",
          position: "fixed",
          zIndex: 10000000,
          backgroundColor: "rgba(0, 0, 0, 0.55)",
          mixBlendMode: "hard-light",
          WebkitOverflowScrolling: "touch",
        } as SxProps,
       onScreenHelpOverlayItem: {
         backgroundColor: "rgb(255, 255, 255) !important",
       }as SxProps,
      
    }
    return classes;
};

